import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import React from 'react';

interface DashboardCardProps {
  title: string;
  count?: number;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

// Internal Dashboard Card Component with improved styling & animation
export const DashboardCard = ({
  title,
  count,
  action,
  children,
  className,
  delay = 0
}: DashboardCardProps) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay, ease: "easeOut" }}
    className={cn("h-full", className)}
  >
    <Card className="bg-card border-border shadow-sm hover:shadow-md hover:border-border transition-all duration-200 overflow-hidden flex flex-col h-full rounded-2xl group/card">
      <div className="flex items-center justify-between p-6 border-b border-border bg-transparent transition-colors duration-200">
        <div className="flex items-center gap-2.5">
          <h3 className="text-base font-semibold text-card-foreground tracking-tight">{title}</h3>
          {count !== undefined && (
            <Badge variant="secondary" className="px-1.5 min-w-[20px] h-5 text-[10px] flex items-center justify-center bg-muted text-muted-foreground border-border rounded-md">
              {count}
            </Badge>
          )}
        </div>
        {action}
      </div>
      <CardContent className="p-0 flex-1 relative bg-transparent">
        {children}
      </CardContent>
    </Card>
  </motion.div>
);
